import React from "react";
import { Link, NavLink } from "react-router-dom";
import HomeIcon from "../../images/home.svg";
import ExploreIcon from "../../images/expoInactive.svg";
function TopNav() {
  return (
    <div className="bg-[#000000] items-center p-3 top-nav">
      <div className="desktop-toggle  section-wrap flex items-center justify-between">
        <div className="flex items-center gap-6">
          <NavLink activeclassname="active" className="" to="../hotel-list">
            <div className="flex items-center gap-2 menu  ">
              <img className="botImg w-4 h-4" src={HomeIcon} />
              <div
                className= "text-gray-400"
              >
                My Hotel
              </div>
            </div>
          </NavLink>
          <NavLink
            activeclassname="active"
            aria-current="page"
            className="active"
            to="../"
          >
            <div className="flex items-center gap-3 menu ">
              <div className="flex flex-col  items-center cursor-pointer">
                <img className="botImg w-5 h-5" src={ExploreIcon} />
              </div>
              <div  className= "text-white font-semibold">Explore</div>
            </div>
          </NavLink>
        </div>
      </div>
    </div>
  );
}

export default TopNav;
